$(function(){
  var ww = $(window).width();
  if(ww < 880) {
  // NEWS 折り畳み
      if($('.store__news__list li').length >= 4){
        var autoHeight = $('.store__news__list').height();
        var height1 = $('.store__news__list li:first-child').height();
        var height2 = $('.store__news__list li:nth-child(2)').height();
        var height3 = $('.store__news__list li:nth-child(3)').height();
        var shortHeight = height1 + height2 + height3 + 120;
        $('.store__news__list').height(shortHeight);
        $('.store__news__list').after('<p id="info-more">MORE</p>');
        $('#info-more').on('click', function(){
          if($('.store__news__list').hasClass('active')) {
            $('.store__news__list').animate({
              height: shortHeight
            }, 500);
            $('.store__news__list').removeClass('active');
          }else {
            $('.store__news__list').animate({
              height: autoHeight
            }, 500);
            $('.store__news__list').addClass('active');
          }            
        });
      }else {
          var autoHeight = $('.store__right');
          console.log(autoHeight);
          $('.store__left').height(autoHeight);
      }
  }

  if($('.store__news__list li').length) {
    $('.store__news').show();
  }else {
    $('.store__news').hide();
  }

  if($('.store__service__list li').length) {
    $('.store__service').show();
  }else {
    $('.store__service').hide();
  }
});

$(window).on('load resize', function(){
    var ww = $(window).width();
    if(ww < 880) {
        // スライド
        $('.store__img').not('.slick-initialized').slick({
            dots: true,
            autoplay: true
        });      
    }else {
        $('.store__img.slick-initialized').slick('unslick');
    }
});
